module.exports = __webpack_public_path__ + "static/img/PR@2x.992090f9.jpg";